import React from "react";
import { Button } from "@/components/ui/button";
import { FileEdit, Pencil } from "lucide-react";

export const ExceptionSection = ({ member, editing, exceptionText, onStartEdit, onSave, onCancel, onTextChange }) => (
  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4" data-testid="exception-section">
    <div className="flex items-center justify-between mb-2">
      <h3 className="text-sm font-semibold text-amber-800 flex items-center gap-2">
        <FileEdit size={14} /> Note client / Exception
      </h3>
      {!editing ? (
        <Button variant="ghost" size="sm" onClick={onStartEdit} data-testid="edit-exception-btn">
          <Pencil size={12} className="mr-1" /> {member.exception ? "Modifier" : "Ajouter"}
        </Button>
      ) : (
        <div className="flex gap-1">
          <Button size="sm" onClick={onSave} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="save-exception-btn">Enregistrer</Button>
          <Button variant="ghost" size="sm" onClick={onCancel}>Annuler</Button>
        </div>
      )}
    </div>
    {editing ? (
      <textarea
        value={exceptionText}
        onChange={(e) => onTextChange(e.target.value)}
        className="w-full rounded border border-amber-300 p-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-amber-400"
        rows={3}
        placeholder="Ex: Tarif spécial accordé suite à... / Exception sur la durée..."
        data-testid="exception-textarea"
      />
    ) : (
      <p className="text-sm text-amber-700">{member.exception || "Aucune exception enregistrée"}</p>
    )}
  </div>
);
